var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{attrs:{"href":_vm.param.data.url}},[_c('div',{staticClass:"kc-more-box"},[_c('img',{staticClass:"kc-more",attrs:{"src":_vm.param.data.image,"alt":""}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }